export default __webpack_public_path__ + "static/media/ENSIGN.513943c2.png";